import React from "react";
import { Link } from "react-router-dom";

export const ROSTERLY_WORDMARK = "https://customer-assets-agu9un31.emergentagent.net/job_55cdd8b1-1e82-41a5-9c9d-99f91ee0f93d/artifacts/ok5qhrl0_ChatGPT%20Image%20Sep%2022%2C%202026%2C%2012_56_07%20PM.png";

// Shared full-screen card for Sign In / Sign Up + every Setup step (one flow, one look).
export const AuthShell = ({ steps = [], current = 0, children, back = true, testId = "auth-shell" }) => (
    <div className="fixed inset-0 z-[100000] flex items-center justify-center p-4 overflow-y-auto"
        style={{ background: "radial-gradient(1200px 600px at 50% -10%, rgba(157,76,221,0.18), transparent), #06070C" }} data-testid={testId}>
        <div className="w-full max-w-md rounded-2xl p-6 sm:p-8 space-y-5 shadow-2xl border border-white/10 fade-up" style={{ background: "#0B0D14" }}>
            <img src={ROSTERLY_WORDMARK} alt="Rosterly" data-follow-theme className="h-12 w-auto mx-auto object-contain" />
            {steps.length > 1 && (
                <div className="flex items-center justify-center gap-1.5" data-testid="auth-steps">
                    {steps.map((s, i) => (
                        <span key={s} title={s} data-testid={`auth-step-dot-${i}`}
                            className={`h-1.5 rounded-full transition-[width,background-color] duration-300 ${i === current ? "w-6 bg-[#9D4CDD]" : i < current ? "w-1.5 bg-[#22C55E]" : "w-1.5 bg-white/15"}`} />
                    ))}
                </div>
            )}
            {children}
            {back && <p className="text-[11px] text-white/35 text-center"><Link to="/" className="hover:text-white">← Back to site</Link></p>}
        </div>
    </div>
);

export const AUTH_INPUT = "w-full bg-[#0A0B10] border border-[#1E2233] focus:border-[#9D4CDD] outline-none text-white px-3 py-2.5 rounded-md text-sm";
